
const customSelectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: (base, state) => ({
        ...base,
        background: "transparent",
        border: "none",
        boxShadow: state.isFocused ? null : null,
        color: "black",
        padding: "0px 15px",
        width: '100%',
        minHeight: '35px',
        height: '100%'
    }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: '0px',
        width: '100%',
        paddingTop: '0.25rem',
        paddingBottom: '0.25rem'
    }),
    menu: (base) => ({
        ...base,
        marginTop: 0,
        color: "#000000",
        padding: "0px 0px",
        overflow: 'hidden',
        borderRadius: "8px",
        background: "#FFFFFF",
        boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
        backdropFilter: "blur(10px)",
    }),
    menuList: (base) => ({
        ...base,
        padding: "0px 0px",
    }),
    singleValue: (base) => ({
        ...base,
        color: "#000000",
        padding: "0px 0px",
        alignItems: "center",
        fontWeight: '600',
        display: "flex",
        fontSize: "1em",
        overflow: 'visible',
        top: window.innerWidth > 2000 ? '50%' :'46%'

    }),
    placeholder: (base) => ({
        ...base,
        color: '#C4C4C4',
        fontWeight: '500',
        top: window.innerWidth > 2000 ? '50%' :'46%'
    }),
    option: (provided, state) => ({
        ...provided,
        background: state.isSelected ? "rgba(219, 0, 7, 0.05)" : state.isFocused ? "rgba(219, 0, 7, 0.05)" : "white", // Background color when selected or focused
        color: '#101828',
        fontWeight: "500",
        ':hover': {
            background: "rgba(219, 0, 7, 0.05)", // Hover background color in red
            color: '#101828',
            fontWeight: "500"
        },
    }),
};

export default customSelectStyles;